export const baseURL = "https://62ea80a63a5f1572e87d2d58.mockapi.io/";
